import { Tween } from '@tweenjs/tween.js'
import ArrayHelper from './ArrayHelper'

export function createTween(target, properties, startImmediately) {
  const {
    x,
    y,
    rotation,
    delay,
    duration,
    easing,
    onStart,
    onUpdate,
    onComplete,
    repeat,
    yoyo
  } = properties

  const tween = new Tween(target)
    .to({ x, y, rotation }, duration)
    .onStart(() => {
      onStart && onStart()
    })
    .onUpdate(() => {
      onUpdate && onUpdate()
    })
    .onComplete(() => {
      onComplete && onComplete()
    })

  if (repeat) {
    tween.repeat(repeat)
  }

  if (yoyo) {
    tween.yoyo(true)
  }

  if (delay) {
    tween.delay(delay)
  }

  if (easing) {
    tween.easing(easing)
  }

  if (startImmediately) {
    tween.start()
  }

  return tween
}

export function chainTweens(tweens) {
  for (let i = 0, l = ArrayHelper(tweens).lastIndex(); i < l; i++) {
    tweens[i].chain(tweens[i + 1])
  }

  return tweens[0]
}
